// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/styles/common.css' // global css
import Vant from 'vant'
import 'vant/lib/index.css'
import VideoPlayer from 'vue-video-player'
import imDesk from '@/views/mobile/components/deskAll'

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import '@/permission'
import { Lazyload } from 'vant'

Vue.use(Lazyload)
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(Vant)
Vue.use(VideoPlayer)
Vue.component('imDesk', imDesk)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js